import { Modal } from '@yoweb/ui/components/Modal';
import { DeleteTaskModalContent } from './DeleteTaskModalContent';
import { MODAL_STANDARD_MAX_WIDTH } from '@poplar/constants/modals';
import { jsx as _jsx } from "react/jsx-runtime";
export var DeleteTaskModal = function DeleteTaskModal(_ref) {
  var task = _ref.task,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onTaskDeleted = _ref.onTaskDeleted;
  return /*#__PURE__*/_jsx(Modal, {
    "data-testid": "task-delete-modal",
    hasCloseButton: true,
    hasOwnContent: true,
    isOpen: isOpen,
    onClose: onClose,
    borderless: true,
    aria: {
      labelledby: 'delete-modal-title'
    },
    maxWidth: MODAL_STANDARD_MAX_WIDTH,
    children: /*#__PURE__*/_jsx(DeleteTaskModalContent, {
      task: task,
      onClose: onClose,
      onTaskDeleted: onTaskDeleted
    })
  });
};